import { useState } from "react";
import { useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";
import { GRAPH_SCOPES } from "./graphScopes";
import { mapLoginError } from "./loginErrors";

export const MicrosoftSignInButton = ({
  onError,
}: {
  onError?: (key: string) => void;
}) => {
  const translate = useTranslate();
  const [pending, setPending] = useState(false);
  const onClick = async () => {
    setPending(true);
    try {
      const { error } = await getSupabaseClient().auth.signInWithOAuth({
        provider: "azure",
        // No redirectTo: like SSOAuthButton, return to site_url and let
        // auth-js pick the session up from the URL.
        options: { scopes: GRAPH_SCOPES },
      });
      if (error) throw error;
    } catch (error) {
      setPending(false);
      onError?.(mapLoginError(error));
    }
  };
  return (
    <Button
      type="button"
      className="w-full h-11 gap-2"
      onClick={onClick}
      disabled={pending}
    >
      <MicrosoftLogo />
      {translate("gavion.login.microsoft")}
    </Button>
  );
};

const MicrosoftLogo = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 21 21">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);
